<div #grid class="tw-grid tw-gap-2 tw-p-0.5" [ngClass]="customClass || ''"
     [style.grid-auto-rows.px]="rowHeight"
     [style.grid-template-columns]="'repeat(' + gridCols + ', minmax(0, 1fr))'">
    @for (item of itemsSet; track item.id) {
        <div class="tw-relative tw-flex tw-min-w-0 tw-cursor-pointer tw-overflow-hidden tw-rounded-[20px] tw-border tw-border-solid tw-border-[color:var(--sys-divider)] tw-bg-[var(--sys-card)] tw-text-[var(--sys-text)] tw-shadow-[0_1px_2px_var(--sys-cashregister-shadow-color)] active:tw-bg-[var(--sys-cashregister-pressed)] active:tw-shadow-[0_0_2px_var(--sys-cashregister-shadow-color)]"
             tilbyGestures (click)="itemTap(item)" (longPress)="itemPress(item)">
            <span class="tw-w-2 tw-shrink-0" [ngStyle]="{ 'background-color': accentColor(item) }"></span>
            <div class="tw-flex tw-min-h-0 tw-min-w-0 tw-flex-1 tw-flex-col tw-gap-1 tw-p-1">
                @if (layout === 'card' && showThumbnail) {
                    <div class="tw-flex tw-w-full tw-shrink-0 tw-items-center tw-justify-center tw-overflow-hidden tw-rounded-2xl tw-bg-[var(--sys-cashregister-media-bg)]"
                         [style.height.px]="imageHeight">
                        @if (item.thumbnail) {
                            <img class="tw-pointer-events-none tw-h-full tw-w-full tw-object-cover tw-object-top" [src]="item.thumbnail" alt=""/>
                        } @else {
                            <span class="tw-text-2xl">{{ initials(item) }}</span>
                        }
                    </div>
                }
                <div class="tw-flex tw-flex-none tw-gap-2"
                     [style.height.px]="nameBlockHeight"
                     [ngClass]="displayMode === 'compact' ? 'tw-px-1 tw-py-0.5' : 'tw-p-1'">
                    <p class="tw-m-0 tw-min-w-0 tw-flex-auto tw-self-start tw-overflow-hidden tw-break-words tw-font-medium tw-leading-[1.2] tw-tracking-tight"
                       [ngClass]="displayMode === 'compact' && layout !== 'tab' ? 'tw-line-clamp-1' : 'tw-line-clamp-3'"
                       [style.height.em]="nameLines * 1.2"
                       [ngStyle]="{ 'font-size': fontNameSize + 'px' }">{{ item.name }}</p>
                    <div class="tw-flex tw-flex-none">
                        @if (showItemIcon && item.icon) {
                            <mat-icon class="tw-shrink-0" [style.width.px]="iconSize" [style.height.px]="iconSize" [svgIcon]="item.icon"></mat-icon>
                        }
                        @if (layout === 'tab') {
                            <div class="tw-flex tw-shrink-0 tw-items-center tw-justify-center tw-overflow-hidden tw-rounded-xl tw-bg-[var(--sys-cashregister-media-bg)]
                            tw-border tw-border-[color:var(--sys-divider)]"
                                 [ngClass]="displayMode === 'compact' ? 'tw-h-12 tw-w-[66px]' : 'tw-h-[60px] tw-w-[83px]'">
                                @if (item.thumbnail) {
                                    <img class="tw-pointer-events-none tw-h-full tw-w-full tw-object-cover tw-object-top" [src]="item.thumbnail" alt=""/>
                                } @else {
                                    <span class="tw-text-2xl">{{ initials(item) }}</span>
                                }
                            </div>
                        }
                    </div>
                </div>
                <div class="tw-mt-auto tw-flex"
                     [ngClass]="[displayMode === 'compact' ? 'tw-px-1 tw-py-0.5' : 'tw-p-1', footerStacked ? 'tw-flex-col tw-gap-0.5' : 'tw-items-center tw-gap-2']">
                    <span class="tw-min-w-0 tw-flex-auto tw-overflow-hidden tw-text-ellipsis tw-whitespace-nowrap" [ngStyle]="{ 'font-size': fontPriceSize + 'px' }">
                        {{ showPrices ? ($any(item[priceIdentifier]) | tilbyCurrency) : '***' }}
                    </span>
                    @if (getStockStatus(item); as stock) {
                        <app-showcase-stock-badge [status]="stock.status" [quantity]="stock.stock_quantity"/>
                    }
                </div>
            </div>
        </div>
    }
</div>
